<div class="insurance-data-summary"
    [ngClass]="{'insurance-data-summary--offers-presentation': isOffersPresentationContext}">

  <div *ngIf="headerVisible"
       class="insurance-data-summary__header">
    {{ getTranslationKey('header') | translate }}
  </div>

  <div class="insurance-data-summary__content">
    <div *ngFor="let entry of entries"
         class="insurance-data-summary__entry">
      <span class="insurance-data-summary__entry__label">
        {{ entry.label | translate }}
      </span>
      <span class="insurance-data-summary__entry__value">
        {{ entry.value }}
      </span>
    </div>
  </div>
</div>
